unit settings.useraccess;

interface

uses
  System.SysUtils, System.Classes, System.UITypes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  WEBLib.DBCtrls, WEBLib.DB, Vcl.Grids, Vcl.Menus, WEBLib.Buttons, WEBLib.Grids;

type
  TfrmUserAccess = class(TForm)
    wpMain: TPanel;
    XDataWebDataSet1: TXDataWebDataSet;
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    btnClose: TButton;
    WebDataSource1: TDataSource;
    WebLabel1: TLabel;
    XDataWebDataSet1SLNCODE: TStringField;
    XDataWebDataSet1EMAIL: TStringField;
    XDataWebDataSet1SLNNAME: TStringField;
    XDataWebDataSet1SIGNATURE: TBlobField;
    XDataWebDataSet1PASSWORD: TStringField;
    XDataWebDataSet1ACCESSRIGHTS: TBlobField;
    XDataWebDataSet1EMAILPASSWORD: TStringField;
    XDataWebDataSet1SITES: TIntegerField;
    XDataWebDataSet1USERID: TIntegerField;
    XDataWebDataSet1REPCODE: TStringField;
    XDataWebDataSet1lastlogindatetime: TDateTimeField;
    XDataWebDataSet1loginipaddress: TStringField;
    XDataWebDataSet1logedin: TStringField;
    XDataWebDataSet1loginhostname: TStringField;
    XDataWebDataSet1loginwebip: TStringField;
    XDataWebDataSet1cellnumber: TStringField;
    XDataWebDataSet1mailclient: TIntegerField;
    XDataWebDataSet1smsonly: TStringField;
    XDataWebDataSet1passwordlastchanged: TDateTimeField;
    XDataWebDataSet1smsdieselerrors: TStringField;
    XDataWebDataSet1suspended: TBooleanField;
    WebScrollBox1: TScrollBox;
    WebDBGrid1: TDBGrid;
    btnShowPassword: TButton;
    btnMailPassword: TButton;
    btnWhatsApp: TButton;
    btnNewUser: TButton;
    MessDlg: TMessageDlg;
    procedure btnCloseClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure XDataWebDataSet1AfterPost(DataSet: TDataSet);
    procedure WebFormShow(Sender: TObject);
    procedure WebDBGrid1GetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure btnShowPasswordClick(Sender: TObject);
    procedure btnNewUserClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmUserAccess: TfrmUserAccess;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  settings.useraccesssetup;

procedure TfrmUserAccess.btnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmUserAccess.btnNewUserClick(Sender: TObject);
  var
    LFrm : TfrmUserAccessSetup;
  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmUserAccessSetup) do
      begin
        sUser := '';
        bAppend := True;
      end;
  end;
  procedure AfterShoWModal(AValue: TModalResult);
  begin
    XDataWebDataSet1.Close;
    XDataWebDataSet1.Load;
    //LFrm.WebDBEdit1.Text;
  end;
begin
  LFrm := TfrmUserAccessSetup.CreateNew(@AfterCreate);

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;
  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmUserAccess.btnShowPasswordClick(Sender: TObject);
begin
  MessDlg.ShowDialog(XDataWebDataSet1.FieldByName('password').AsString,
                     WebLib.Dialogs.mtInformation, [mbOK]);
end;

procedure TfrmUserAccess.WebDBGrid1GetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
  var
    btn : TButton;
  procedure btnShowSetupClick(Sender: TObject);
    var
      LFrm : TfrmUserAccessSetup;
    procedure AfterCreate(AForm : TObject);
    begin
      with (AForm as TfrmUserAccessSetup) do
        begin
          XDataWebDataSet1.First;
          XDataWebDataSet1.MoveBy(ARow - 1);
          sUser := XDataWebDataSet1.FieldByName('slncode').asString;
          bAppend := False;
        end;
    end;
    procedure AfterShoWModal(AValue: TModalResult);
    begin
      XDataWebDataSet1.Close;
      XDataWebDataSet1.Load;
    end;
  begin
    LFrm := TfrmUserAccessSetup.CreateNew(@AfterCreate);

    // LFrm als Pop-Up festlegen
    LFrm.Popup := true;

    // Transparenz definieren
    LFrm.PopupOpacity := 0.2;
    LFrm.ShowModal(@AfterShowModal);
  end;
begin
  if ARow < 1 then
    exit;
  if ACol = 7 then
    begin
      btn := TButton.Create(self);
      btn.Caption := 'Edit';
      btn.Width := WebDBGrid1.Columns[ACol].Width;
      btn.Height := 25; //WebDBGrid1.DefaultRowHeight-2;
      btn.Color := $00ECA23B; //$FFE0FFFF;
      btn.Font.Color := clWhite;
      AElement.element.innerHTML := '';
      btn.ParentElement := AElement.element;
      btn.OnClick := btnShowSetupClick;
    end;
end;

procedure TfrmUserAccess.WebFormResize(Sender: TObject);
begin
  wpMain.Left := (Width - wpMain.Width) div 2;
  wpMain.Top := (Height - wpMain.Height) div 2;
end;

procedure TfrmUserAccess.WebFormShow(Sender: TObject);
begin
  XDataWebDataset1.Close;
  XDataWebDataset1.Load;
  if dmdata.LStorage.getvalue(stfmssystem.connection.UserName) = 'SUPPORT' then
    begin
     btnShowPassword.Visible := True;
     btnMailPassword.Visible := True;
     btnWhatsApp.Visible := True;
    end;
end;

procedure TfrmUserAccess.XDataWebDataSet1AfterPost(DataSet: TDataSet);
begin
  XDataWebDataset1.ApplyUpdates;
end;

procedure TfrmUserAccess.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpMain := TPanel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnClose := TButton.Create(Self);
  btnShowPassword := TButton.Create(Self);
  btnMailPassword := TButton.Create(Self);
  btnWhatsApp := TButton.Create(Self);
  btnNewUser := TButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  MessDlg := TMessageDlg.Create(Self);
  XDataWebDataSet1 := TXDataWebDataSet.Create(Self);
  XDataWebDataSet1SLNCODE := TStringField.Create(Self);
  XDataWebDataSet1EMAIL := TStringField.Create(Self);
  XDataWebDataSet1SLNNAME := TStringField.Create(Self);
  XDataWebDataSet1SIGNATURE := TBlobField.Create(Self);
  XDataWebDataSet1PASSWORD := TStringField.Create(Self);
  XDataWebDataSet1ACCESSRIGHTS := TBlobField.Create(Self);
  XDataWebDataSet1EMAILPASSWORD := TStringField.Create(Self);
  XDataWebDataSet1SITES := TIntegerField.Create(Self);
  XDataWebDataSet1USERID := TIntegerField.Create(Self);
  XDataWebDataSet1REPCODE := TStringField.Create(Self);
  XDataWebDataSet1lastlogindatetime := TDateTimeField.Create(Self);
  XDataWebDataSet1loginipaddress := TStringField.Create(Self);
  XDataWebDataSet1logedin := TStringField.Create(Self);
  XDataWebDataSet1loginhostname := TStringField.Create(Self);
  XDataWebDataSet1loginwebip := TStringField.Create(Self);
  XDataWebDataSet1cellnumber := TStringField.Create(Self);
  XDataWebDataSet1mailclient := TIntegerField.Create(Self);
  XDataWebDataSet1smsonly := TStringField.Create(Self);
  XDataWebDataSet1passwordlastchanged := TDateTimeField.Create(Self);
  XDataWebDataSet1smsdieselerrors := TStringField.Create(Self);
  XDataWebDataSet1suspended := TBooleanField.Create(Self);
  WebDataSource1 := TDataSource.Create(Self);

  wpMain.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnShowPassword.BeforeLoadDFMValues;
  btnMailPassword.BeforeLoadDFMValues;
  btnWhatsApp.BeforeLoadDFMValues;
  btnNewUser.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  MessDlg.BeforeLoadDFMValues;
  XDataWebDataSet1.BeforeLoadDFMValues;
  XDataWebDataSet1SLNCODE.BeforeLoadDFMValues;
  XDataWebDataSet1EMAIL.BeforeLoadDFMValues;
  XDataWebDataSet1SLNNAME.BeforeLoadDFMValues;
  XDataWebDataSet1SIGNATURE.BeforeLoadDFMValues;
  XDataWebDataSet1PASSWORD.BeforeLoadDFMValues;
  XDataWebDataSet1ACCESSRIGHTS.BeforeLoadDFMValues;
  XDataWebDataSet1EMAILPASSWORD.BeforeLoadDFMValues;
  XDataWebDataSet1SITES.BeforeLoadDFMValues;
  XDataWebDataSet1USERID.BeforeLoadDFMValues;
  XDataWebDataSet1REPCODE.BeforeLoadDFMValues;
  XDataWebDataSet1lastlogindatetime.BeforeLoadDFMValues;
  XDataWebDataSet1loginipaddress.BeforeLoadDFMValues;
  XDataWebDataSet1logedin.BeforeLoadDFMValues;
  XDataWebDataSet1loginhostname.BeforeLoadDFMValues;
  XDataWebDataSet1loginwebip.BeforeLoadDFMValues;
  XDataWebDataSet1cellnumber.BeforeLoadDFMValues;
  XDataWebDataSet1mailclient.BeforeLoadDFMValues;
  XDataWebDataSet1smsonly.BeforeLoadDFMValues;
  XDataWebDataSet1passwordlastchanged.BeforeLoadDFMValues;
  XDataWebDataSet1smsdieselerrors.BeforeLoadDFMValues;
  XDataWebDataSet1suspended.BeforeLoadDFMValues;
  WebDataSource1.BeforeLoadDFMValues;
  try
    Name := 'frmUserAccess';
    Width := 1024;
    Height := 768;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    wpMain.SetParentComponent(Self);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 0;
    wpMain.Width := 1024;
    wpMain.Height := 768;
    wpMain.ElementClassName := 'card';
    wpMain.Align := alClient;
    wpMain.Color := clSilver;
    wpMain.ElementBodyClassName := 'card-body';
    wpMain.ElementFont := efCSS;
    wpMain.TabOrder := 0;
    WebPanel1.SetParentComponent(wpMain);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 703;
    WebPanel1.Width := 1024;
    WebPanel1.Height := 65;
    WebPanel1.ElementClassName := 'card';
    WebPanel1.Align := alBottom;
    WebPanel1.BorderStyle := bsNone;
    WebPanel1.ChildOrder := 1;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.ElementFont := efCSS;
    WebPanel1.ShowCaption := False;
    WebPanel1.TabOrder := 0;
    btnClose.SetParentComponent(WebPanel1);
    btnClose.Name := 'btnClose';
    btnClose.Left := 882;
    btnClose.Top := 6;
    btnClose.Width := 139;
    btnClose.Height := 49;
    btnClose.Caption := 'Close';
    btnClose.Color := clCrimson;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWhite;
    btnClose.Font.Height := -13;
    btnClose.Font.Name := 'Tahoma';
    btnClose.Font.Style := [];
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.ParentFont := False;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnShowPassword.SetParentComponent(WebPanel1);
    btnShowPassword.Name := 'btnShowPassword';
    btnShowPassword.Left := 17;
    btnShowPassword.Top := 6;
    btnShowPassword.Width := 139;
    btnShowPassword.Height := 49;
    btnShowPassword.Caption := 'Show Password';
    btnShowPassword.Color := clLightseagreen;
    btnShowPassword.ChildOrder := 1;
    btnShowPassword.Font.Charset := DEFAULT_CHARSET;
    btnShowPassword.Font.Color := clWhite;
    btnShowPassword.Font.Height := -13;
    btnShowPassword.Font.Name := 'Tahoma';
    btnShowPassword.Font.Style := [];
    btnShowPassword.HeightStyle := ssAuto;
    btnShowPassword.HeightPercent := 100.000000000000000000;
    btnShowPassword.ParentFont := False;
    btnShowPassword.Visible := False;
    btnShowPassword.WidthPercent := 100.000000000000000000;
    SetEvent(btnShowPassword, Self, 'OnClick', 'btnShowPasswordClick');
    btnMailPassword.SetParentComponent(WebPanel1);
    btnMailPassword.Name := 'btnMailPassword';
    btnMailPassword.Left := 162;
    btnMailPassword.Top := 6;
    btnMailPassword.Width := 139;
    btnMailPassword.Height := 49;
    btnMailPassword.Caption := 'E-Mail';
    btnMailPassword.Color := clLightseagreen;
    btnMailPassword.ChildOrder := 2;
    btnMailPassword.Font.Charset := DEFAULT_CHARSET;
    btnMailPassword.Font.Color := clWhite;
    btnMailPassword.Font.Height := -13;
    btnMailPassword.Font.Name := 'Tahoma';
    btnMailPassword.Font.Style := [];
    btnMailPassword.HeightStyle := ssAuto;
    btnMailPassword.HeightPercent := 100.000000000000000000;
    btnMailPassword.ParentFont := False;
    btnMailPassword.Visible := False;
    btnMailPassword.WidthPercent := 100.000000000000000000;
    SetEvent(btnMailPassword, Self, 'OnClick', 'btnCloseClick');
    btnWhatsApp.SetParentComponent(WebPanel1);
    btnWhatsApp.Name := 'btnWhatsApp';
    btnWhatsApp.Left := 310;
    btnWhatsApp.Top := 6;
    btnWhatsApp.Width := 139;
    btnWhatsApp.Height := 49;
    btnWhatsApp.Caption := 'WhatsApp';
    btnWhatsApp.Color := clLightseagreen;
    btnWhatsApp.ChildOrder := 3;
    btnWhatsApp.Font.Charset := DEFAULT_CHARSET;
    btnWhatsApp.Font.Color := clWhite;
    btnWhatsApp.Font.Height := -13;
    btnWhatsApp.Font.Name := 'Tahoma';
    btnWhatsApp.Font.Style := [];
    btnWhatsApp.HeightStyle := ssAuto;
    btnWhatsApp.HeightPercent := 100.000000000000000000;
    btnWhatsApp.ParentFont := False;
    btnWhatsApp.Visible := False;
    btnWhatsApp.WidthPercent := 100.000000000000000000;
    SetEvent(btnWhatsApp, Self, 'OnClick', 'btnCloseClick');
    btnNewUser.SetParentComponent(WebPanel1);
    btnNewUser.Name := 'btnNewUser';
    btnNewUser.Left := 465;
    btnNewUser.Top := 6;
    btnNewUser.Width := 139;
    btnNewUser.Height := 49;
    btnNewUser.Caption := 'New User';
    btnNewUser.Color := 15508027;
    btnNewUser.ChildOrder := 4;
    btnNewUser.Font.Charset := DEFAULT_CHARSET;
    btnNewUser.Font.Color := clWhite;
    btnNewUser.Font.Height := -13;
    btnNewUser.Font.Name := 'Tahoma';
    btnNewUser.Font.Style := [];
    btnNewUser.HeightStyle := ssAuto;
    btnNewUser.HeightPercent := 100.000000000000000000;
    btnNewUser.ParentFont := False;
    btnNewUser.WidthPercent := 100.000000000000000000;
    SetEvent(btnNewUser, Self, 'OnClick', 'btnNewUserClick');
    WebPanel2.SetParentComponent(wpMain);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 1024;
    WebPanel2.Height := 33;
    WebPanel2.ElementClassName := 'card';
    WebPanel2.Align := alTop;
    WebPanel2.BorderStyle := bsNone;
    WebPanel2.ChildOrder := 1;
    WebPanel2.ElementBodyClassName := 'card-body';
    WebPanel2.ElementFont := efCSS;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -13;
    WebPanel2.Font.Name := 'Tahoma';
    WebPanel2.Font.Style := [];
    WebPanel2.ParentFont := False;
    WebPanel2.ShowCaption := False;
    WebPanel2.TabOrder := 1;
    WebLabel1.SetParentComponent(WebPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 1024;
    WebLabel1.Height := 33;
    WebLabel1.Align := alClient;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'User Setup';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebScrollBox1.SetParentComponent(wpMain);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 33;
    WebScrollBox1.Width := 1024;
    WebScrollBox1.Height := 670;
    WebScrollBox1.ElementClassName := 'card';
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 3;
    WebDBGrid1.SetParentComponent(WebScrollBox1);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 0;
    WebDBGrid1.Top := 0;
    WebDBGrid1.Width := 1024;
    WebDBGrid1.Height := 670;
    WebDBGrid1.Align := alClient;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'SLNCODE';
      Title := 'Code';
      Width := 90;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'SLNNAME';
      Title := 'Name';
      Width := 199;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'EMAIL';
      Title := 'E-Mail';
      Width := 225;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'cellnumber';
      Title := 'Cell Number';
      Width := 117;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'SITES';
      Title := 'Site';
      Width := 170;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'passwordlastchanged';
      Title := 'Last Changed';
      Width := 145;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'suspended';
      DataType := cdCheck;
      Title := 'Suspended';
      Width := 86;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      Width := 79;
    end;
    WebDBGrid1.DefaultRowHeight := 27;
    WebDBGrid1.DataSource := WebDataSource1;
    WebDBGrid1.FixedFont.Charset := DEFAULT_CHARSET;
    WebDBGrid1.FixedFont.Color := clWindowText;
    WebDBGrid1.FixedFont.Height := -12;
    WebDBGrid1.FixedFont.Name := 'Segoe UI';
    WebDBGrid1.FixedFont.Style := [];
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.Font.Charset := DEFAULT_CHARSET;
    WebDBGrid1.Font.Color := clWindowText;
    WebDBGrid1.Font.Height := -13;
    WebDBGrid1.Font.Name := 'Tahoma';
    WebDBGrid1.Font.Style := [];
    WebDBGrid1.ParentFont := False;
    WebDBGrid1.TabOrder := 0;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid1, Self, 'OnGetCellChildren', 'WebDBGrid1GetCellChildren');
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 90;
    WebDBGrid1.ColWidths[2] := 199;
    WebDBGrid1.ColWidths[3] := 225;
    WebDBGrid1.ColWidths[4] := 117;
    WebDBGrid1.ColWidths[5] := 170;
    WebDBGrid1.ColWidths[6] := 145;
    WebDBGrid1.ColWidths[7] := 86;
    WebDBGrid1.ColWidths[8] := 79;
    MessDlg.SetParentComponent(WebScrollBox1);
    MessDlg.Name := 'MessDlg';
    MessDlg.Left := 592;
    MessDlg.Top := 168;
    MessDlg.Width := 24;
    MessDlg.Height := 24;
    MessDlg.Buttons := [mbOK];
    MessDlg.DialogType := mtInformation;
    MessDlg.Opacity := 0.200000000000000000;
    MessDlg.Title := 'User Password';
    MessDlg.ElementButtonClassName := 'btn';
    MessDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MessDlg.ElementTitleClassName := 'text-body';
    MessDlg.ElementContentClassName := 'text-body';
    XDataWebDataSet1.SetParentComponent(Self);
    XDataWebDataSet1.Name := 'XDataWebDataSet1';
    XDataWebDataSet1.AfterPost := XDataWebDataSet1AfterPost;
    XDataWebDataSet1.EntitySetName := 'workemail';
    XDataWebDataSet1.Connection := dmData.dbConnect;
    XDataWebDataSet1.Left := 176;
    XDataWebDataSet1.Top := 160;
    XDataWebDataSet1SLNCODE.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1SLNCODE.Name := 'XDataWebDataSet1SLNCODE';
    XDataWebDataSet1SLNCODE.FieldName := 'SLNCODE';
    XDataWebDataSet1SLNCODE.Required := True;
    XDataWebDataSet1SLNCODE.Size := 10;
    XDataWebDataSet1EMAIL.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1EMAIL.Name := 'XDataWebDataSet1EMAIL';
    XDataWebDataSet1EMAIL.FieldName := 'EMAIL';
    XDataWebDataSet1EMAIL.Required := True;
    XDataWebDataSet1EMAIL.Size := 100;
    XDataWebDataSet1SLNNAME.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1SLNNAME.Name := 'XDataWebDataSet1SLNNAME';
    XDataWebDataSet1SLNNAME.FieldName := 'SLNNAME';
    XDataWebDataSet1SLNNAME.Size := 50;
    XDataWebDataSet1SIGNATURE.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1SIGNATURE.Name := 'XDataWebDataSet1SIGNATURE';
    XDataWebDataSet1SIGNATURE.FieldName := 'SIGNATURE';
    XDataWebDataSet1PASSWORD.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1PASSWORD.Name := 'XDataWebDataSet1PASSWORD';
    XDataWebDataSet1PASSWORD.FieldName := 'PASSWORD';
    XDataWebDataSet1PASSWORD.Size := 50;
    XDataWebDataSet1ACCESSRIGHTS.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1ACCESSRIGHTS.Name := 'XDataWebDataSet1ACCESSRIGHTS';
    XDataWebDataSet1ACCESSRIGHTS.FieldName := 'ACCESSRIGHTS';
    XDataWebDataSet1EMAILPASSWORD.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1EMAILPASSWORD.Name := 'XDataWebDataSet1EMAILPASSWORD';
    XDataWebDataSet1EMAILPASSWORD.FieldName := 'EMAILPASSWORD';
    XDataWebDataSet1EMAILPASSWORD.Size := 25;
    XDataWebDataSet1SITES.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1SITES.Name := 'XDataWebDataSet1SITES';
    XDataWebDataSet1SITES.FieldName := 'SITES';
    XDataWebDataSet1USERID.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1USERID.Name := 'XDataWebDataSet1USERID';
    XDataWebDataSet1USERID.FieldName := 'USERID';
    XDataWebDataSet1REPCODE.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1REPCODE.Name := 'XDataWebDataSet1REPCODE';
    XDataWebDataSet1REPCODE.FieldName := 'REPCODE';
    XDataWebDataSet1REPCODE.Size := 10;
    XDataWebDataSet1lastlogindatetime.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1lastlogindatetime.Name := 'XDataWebDataSet1lastlogindatetime';
    XDataWebDataSet1lastlogindatetime.FieldName := 'lastlogindatetime';
    XDataWebDataSet1loginipaddress.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1loginipaddress.Name := 'XDataWebDataSet1loginipaddress';
    XDataWebDataSet1loginipaddress.FieldName := 'loginipaddress';
    XDataWebDataSet1loginipaddress.Size := 45;
    XDataWebDataSet1logedin.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1logedin.Name := 'XDataWebDataSet1logedin';
    XDataWebDataSet1logedin.FieldName := 'logedin';
    XDataWebDataSet1logedin.Size := 1;
    XDataWebDataSet1loginhostname.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1loginhostname.Name := 'XDataWebDataSet1loginhostname';
    XDataWebDataSet1loginhostname.FieldName := 'loginhostname';
    XDataWebDataSet1loginhostname.Size := 45;
    XDataWebDataSet1loginwebip.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1loginwebip.Name := 'XDataWebDataSet1loginwebip';
    XDataWebDataSet1loginwebip.FieldName := 'loginwebip';
    XDataWebDataSet1loginwebip.Size := 45;
    XDataWebDataSet1cellnumber.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1cellnumber.Name := 'XDataWebDataSet1cellnumber';
    XDataWebDataSet1cellnumber.FieldName := 'cellnumber';
    XDataWebDataSet1cellnumber.Size := 45;
    XDataWebDataSet1mailclient.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1mailclient.Name := 'XDataWebDataSet1mailclient';
    XDataWebDataSet1mailclient.FieldName := 'mailclient';
    XDataWebDataSet1smsonly.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1smsonly.Name := 'XDataWebDataSet1smsonly';
    XDataWebDataSet1smsonly.FieldName := 'smsonly';
    XDataWebDataSet1smsonly.Size := 1;
    XDataWebDataSet1passwordlastchanged.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1passwordlastchanged.Name := 'XDataWebDataSet1passwordlastchanged';
    XDataWebDataSet1passwordlastchanged.FieldName := 'passwordlastchanged';
    XDataWebDataSet1passwordlastchanged.DisplayFormat := 'DD/MM/YYYY HH:mm:ss';
    XDataWebDataSet1smsdieselerrors.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1smsdieselerrors.Name := 'XDataWebDataSet1smsdieselerrors';
    XDataWebDataSet1smsdieselerrors.FieldName := 'smsdieselerrors';
    XDataWebDataSet1smsdieselerrors.Size := 1;
    XDataWebDataSet1suspended.SetParentComponent(XDataWebDataSet1);
    XDataWebDataSet1suspended.Name := 'XDataWebDataSet1suspended';
    XDataWebDataSet1suspended.FieldName := 'suspended';
    WebDataSource1.SetParentComponent(Self);
    WebDataSource1.Name := 'WebDataSource1';
    WebDataSource1.DataSet := XDataWebDataSet1;
    WebDataSource1.Left := 280;
    WebDataSource1.Top := 192;
  finally
    wpMain.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnShowPassword.AfterLoadDFMValues;
    btnMailPassword.AfterLoadDFMValues;
    btnWhatsApp.AfterLoadDFMValues;
    btnNewUser.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    MessDlg.AfterLoadDFMValues;
    XDataWebDataSet1.AfterLoadDFMValues;
    XDataWebDataSet1SLNCODE.AfterLoadDFMValues;
    XDataWebDataSet1EMAIL.AfterLoadDFMValues;
    XDataWebDataSet1SLNNAME.AfterLoadDFMValues;
    XDataWebDataSet1SIGNATURE.AfterLoadDFMValues;
    XDataWebDataSet1PASSWORD.AfterLoadDFMValues;
    XDataWebDataSet1ACCESSRIGHTS.AfterLoadDFMValues;
    XDataWebDataSet1EMAILPASSWORD.AfterLoadDFMValues;
    XDataWebDataSet1SITES.AfterLoadDFMValues;
    XDataWebDataSet1USERID.AfterLoadDFMValues;
    XDataWebDataSet1REPCODE.AfterLoadDFMValues;
    XDataWebDataSet1lastlogindatetime.AfterLoadDFMValues;
    XDataWebDataSet1loginipaddress.AfterLoadDFMValues;
    XDataWebDataSet1logedin.AfterLoadDFMValues;
    XDataWebDataSet1loginhostname.AfterLoadDFMValues;
    XDataWebDataSet1loginwebip.AfterLoadDFMValues;
    XDataWebDataSet1cellnumber.AfterLoadDFMValues;
    XDataWebDataSet1mailclient.AfterLoadDFMValues;
    XDataWebDataSet1smsonly.AfterLoadDFMValues;
    XDataWebDataSet1passwordlastchanged.AfterLoadDFMValues;
    XDataWebDataSet1smsdieselerrors.AfterLoadDFMValues;
    XDataWebDataSet1suspended.AfterLoadDFMValues;
    WebDataSource1.AfterLoadDFMValues;
  end;
end;

end.